import type { ScopeNode } from "@/components/ChannelMenu";

// Flattens a scope tree to its clickable leaf channels, in the same order
// the ChannelMenu dropdown walks them (parent first, then its children),
// so the tab strip and the old dropdown list channels the same way.
export function leafChannelsInTreeOrder(tree: ScopeNode[]): ScopeNode[] {
  const ids = new Set(tree.map((n) => n.id));
  const children = new Map<string | null, ScopeNode[]>();
  tree.forEach((n) => {
    const key = n.parent_id !== null && ids.has(n.parent_id) ? n.parent_id : null;
    const list = children.get(key) ?? [];
    list.push(n);
    children.set(key, list);
  });

  const out: ScopeNode[] = [];
  const walk = (node: ScopeNode) => {
    if (node.is_leaf && node.authorized) out.push(node);
    (children.get(node.id) ?? []).forEach(walk);
  };
  (children.get(null) ?? []).forEach(walk);
  return out;
}
